import { GetRowIdParams, GridReadyEvent, GridOptions, ColDef } from '@ag-grid-community/core';
import { Component, Input, OnInit } from '@angular/core';
import { GridOptionsExt, AgFns, ISortModel } from '@core';
import { ActivationBaseService, ICheckListItem } from '@services';

@Component({
  selector: 'prox-activation-checklist',
  standalone: false,
  templateUrl: './activation-checklist.component.html',
})
export class ActivationChecklistComponent implements OnInit {
  @Input() activationErrors: ICheckListItem[] = [];
  @Input() entityName!: string;
  @Input() activationService!: ActivationBaseService;

  gridOptions: GridOptionsExt = {};

  ngOnInit(): void {
    this.gridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onGridReady,
      getRowId: (rowIdParams: GetRowIdParams) => {
        const x = rowIdParams.data as ICheckListItem;
        return x.index.toString();
      },
    });
  }

  onGridReady(event: GridReadyEvent) {
    const gridOptions = event.context.gridOptions as GridOptions;
    const [colDefs, sortModel] = this.getColDefsAndSortModel();

    AgFns.initGrid(event, colDefs, sortModel);
    AgFns.applyGridRouteParams(gridOptions);
  }

  getColDefsAndSortModel() {
    const colDefs: ColDef[] = [
      {
        ...AgFns.createButtonProps(' ', this.onFix.bind(this), {
          label: 'Fix This',
        }),
        ...AgFns.fixWidth(80),
      },
      { headerName: 'Error', field: 'description', ...AgFns.flexWidth(40) },
      { headerName: 'More Info', field: 'info', ...AgFns.flexWidth(60) },
    ];
    const sortModel: ISortModel = [{ colId: 'index', sort: 'asc' }];
    return [colDefs, sortModel] as const;
  }

  onFix(row: ICheckListItem) {
    this.activationService.routeTo(row.route);
  }
}
